var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"panel-icon",attrs:{"src":"/logo_small.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }